import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { Sidebar } from '../../BulkActionsSidebar'
import {
  BulkReassignFormModel,
  ValidationCallback,
  SubmitCallback,
} from './typings'
import { FormFields } from './FormFields'
import { useFormActions } from './hooks'
import { validate } from './functions'

const initialValues: BulkReassignFormModel = {
  salesTeamId: '',
  assigneeId: '',
  removeServices: false,
}

type Props = {
  entityType: ENTITY_TYPES
  validateRows: ValidationCallback
  onSubmit: SubmitCallback
}

export const BulkReassignForm: React.FC<Props> = (props) => {
  const { submitHandler, ...data } = useFormActions(props)

  return (
    <Sidebar
      title="reassign"
      titleSx={{ textTransform: 'capitalize' }}
      initialValues={initialValues}
      onSubmit={submitHandler}
      validate={validate}
      validateOnBlur={false}
    >
      <FormFields {...props} {...data} />
    </Sidebar>
  )
}
BulkReassignForm.displayName = 'BulkReassignForm'
